/**
 * Secondary popups: careers "Apply Now" (hiring) and "Write for us".
 * Triggers use data-popup="hiring" / data-popup="write-for-us".
 * (The main contact popup lives in popup.js.)
 */
document.addEventListener('DOMContentLoaded', function () {
    function bindPopup(popupId, triggerSelector) {
        var popup = document.getElementById(popupId);
        if (!popup) return;

        function open(e) {
            if (e) e.preventDefault();
            popup.classList.add('active');
            popup.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
        }

        function close() {
            popup.classList.remove('active');
            popup.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
        }

        document.addEventListener('click', function (e) {
            if (e.target.closest(triggerSelector)) open(e);
        });

        popup.querySelectorAll('.contact-popup__close, .contact-popup__overlay').forEach(function (el) {
            el.addEventListener('click', close);
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && popup.classList.contains('active')) close();
        });
    }

    bindPopup('hiring-popup', '[data-popup="hiring"]');
    bindPopup('write-for-us-popup', '[data-popup="write-for-us"]');
});
